import { LOAD_REGISTER_MODALS, LOAD_FORGOTTEN_PASSWORD_MODALS } from "../constants";
export const toggleLoadRegisterModals = value => ({
  type: LOAD_REGISTER_MODALS,
  value
});
export const toggleLoadForgottenPasswordModals = value => ({
  type: LOAD_FORGOTTEN_PASSWORD_MODALS,
  value
});